import { useSelector } from "react-redux";
import { selectMeProfile } from "views/auth/sagas/meSlice";
import { PermissionAction, PermissionModule } from "models";

export const usePermissions = () => {
  const profile = useSelector(selectMeProfile);

  const hasPermission = (module: PermissionModule, action: PermissionAction): boolean => {
    if (!profile) return false;
    
    // Super admin has all permissions
    if (profile.isSuperAdmin) return true;

    const modulePermissions = profile.permissions?.find((p) => p.module === module);
    if (!modulePermissions) return false;

    return modulePermissions.actions.includes(action);
  };

  return { hasPermission, profile };
};
